module.exports = __webpack_public_path__ + "img/layout-6_4.a23927b4.png";